import { evaluarActivo } from './consent'

// Checklist de reglas de activacion (lista extensible) + si todas cumplen.
// Entrada YA calculada (sin I/O): curpValida, trataDatos, exigirConsentimiento.
export const evaluarReglasActivacion = ({
  curpValida = false,
  trataDatos = false,
  exigirConsentimiento = false,
} = {}) => {
  const base = evaluarActivo({ curpValida, trataDatos, exigirConsentimiento })
  const reglas = [
    { key: 'curp', label: 'Datos válidos (CURP)', aplica: true, cumple: !base.faltaCurp },
    {
      key: 'consentimiento',
      label: 'Consentimiento',
      aplica: !!exigirConsentimiento,
      cumple: !base.faltaConsentimiento,
    },
  ]
  return { reglas, todasCumplen: base.ok }
}

// Estado que se MUESTRA, derivado del estatus guardado + si cumple reglas.
export const estadoMostrado = ({ estatusGuardado, todasCumplen } = {}) => {
  if (estatusGuardado === 'baja') return 'baja'
  if (estatusGuardado === 'activo') return todasCumplen ? 'activo' : 'revision'
  return 'pendiente'
}

// El boton "Activar" se habilita solo si esta pendiente y cumple todas las reglas.
export const puedeActivar = ({ estatusGuardado, todasCumplen } = {}) =>
  estatusGuardado === 'pendiente' && !!todasCumplen

// "Realmente activo" (lo que leeran el cobro y el candado de grupo en F2).
export const esRealmenteActivo = ({ estatusGuardado, todasCumplen } = {}) =>
  estatusGuardado === 'activo' && !!todasCumplen
